import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';

// todo: remove this after detaching cra from gatsby completely - navbar
let history;
if (typeof window !== 'undefined') {
  history = createBrowserHistory();
}

const Init = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 1.0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    profilesSampleRate: 1.0,
    tracesSampleRate: 1.0, // Adjust the sample rate as needed
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        tracingOrigins: [
          'localhost', // Include localhost for local development
          /https:\/\/([a-zA-Z0-9]+).execute-api.[a-z0-9-]+.amazonaws.com\/.*/, // Match all AWS API Gateway URLs
          /https:\/\/apistage.wisedoc.net\/.*/,
          /https:\/\/api.wisedoc.net\/.*/,
          /https:\/\/apitetra.wisedoc.net\/.*/,
        ],
      }),
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: false,
        blockAllMedia: false,
        networkDetailAllowUrls: [
          /https:\/\/([a-zA-Z0-9]+).execute-api.[a-z0-9-]+.amazonaws.com\/.*/, // Match all AWS API Gateway URLs
          /https:\/\/apistage.wisedoc.net\/.*/,
          /https:\/\/api.wisedoc.net\/.*/,
          /https:\/\/apitetra.wisedoc.net\/.*/,
        ],
        networkRequestHeaders: ['X-Custom-Header'],
        networkResponseHeaders: ['X-Custom-Header'],
      }),
      Sentry.feedbackIntegration({
        // Additional SDK configuration goes in here, for example:
        colorScheme: 'system',
        showBranding: false,

        useSentryUser: {
          email: 'id',
          name: 'name',
        },
      }),
      // Add browser profiling integration to the list of integrations
      new Sentry.BrowserProfilingIntegration(),
      new Sentry.BrowserTracing(),
    ],
  });
};

const LogUncaughtError = (error, errorInfo) => {
  Sentry.withScope((scope) => {
    Object.keys(errorInfo).forEach((key) => {
      scope.setExtra(key, errorInfo[key]);
    });
    if (navigator.connection) {
      Sentry.setTag('Network Type', navigator.connection.effectiveType);
    }
    Sentry.captureException(error);
  });
};

const LogError = (error, errorInfo = {}) => {
  // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  //   console.error('SENTRY LOG', error);
  // }
  Sentry.withScope((scope) => {
    Object.keys(errorInfo).forEach((key) => {
      scope.setExtra(key, errorInfo[key]);
    });
    if (navigator.connection) {
      Sentry.setTag('Network Type', navigator.connection.effectiveType);
    }
    Sentry.captureException(error);
  });
};

const Log = (message) => {
  if (navigator.connection) {
    Sentry.setTag('Network Type', navigator.connection.effectiveType);
  }
  Sentry.captureMessage(message);
};

const SetUserLogScope = (id, name) => {
  Sentry.configureScope((scope) => {
    scope.setUser({
      id,
      name,
    });
  });
};

const ClearUserLogScope = () => {
  Sentry.configureScope((scope) => {
    scope.setUser({
      id: null,
    });
  });
};

export default {
  Init,
  LogUncaughtError,
  Log,
  LogError,
  SetUserLogScope,
  ClearUserLogScope,
};
